import { Observable } from 'rxjs/Observable';
import { async } from 'rxjs/scheduler/async';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/from';
import log from '@atlassian/jira-common-util-logging/src/log';
import { loadPlanDataService } from '../../../services/load-plan-data';
import { makeServiceContext } from '../../../services/service-context';
import { type SetAppDataAction, setAppData } from '../../../state/actions/app';
import {
	type FilteredCardClearRequestAction,
	type Action as FilteredCardsAction,
	FILTERED_CARD_CLEAR_REQUEST,
	clearFilteredCardsSuccess,
	clearFilteredCardsFailed,
} from '../../../state/actions/cards/filtered-cards';
import type { ActionsObservable, Dependencies, MiddlewareAPI } from '../../../state/types';
import { getCustomFiltersDebounceTime } from '../utils';

export const fetchUnfilteredCards = (
	action: FilteredCardClearRequestAction,
	store: MiddlewareAPI,
	dependencies?: Dependencies,
): Observable<FilteredCardsAction | SetAppDataAction> => {
	const state = store.getState();
	const { analyticsEvent } = action.meta;

	const ctx = makeServiceContext(state);

	return loadPlanDataService({
		boardId: ctx.boardId,
		isCompanyManaged: ctx.isCompanyManaged,
		epicIssueType: null,
		storeFieldsActions: dependencies?.storeFieldsActions,
	})
		.mergeMap((data) =>
			Observable.from([clearFilteredCardsSuccess(analyticsEvent), setAppData(data)]),
		)
		.catch((error) => {
			log.safeErrorWithoutCustomerData(
				'backlog.clear-filtered-cards.failure',
				'Failed to load plan data to clear cards filter',
				error,
			);
			return Observable.of<FilteredCardsAction>(clearFilteredCardsFailed(error, analyticsEvent));
		});
};

export const clearFilterRequestEpic = (
	action$: ActionsObservable,
	store: MiddlewareAPI,
	dependencies?: Dependencies,
) =>
	action$
		.ofType(FILTERED_CARD_CLEAR_REQUEST)
		.throttleTime(getCustomFiltersDebounceTime(), async, {
			leading: true,
			trailing: true,
		})
		.switchMap((action: FilteredCardClearRequestAction) =>
			fetchUnfilteredCards(action, store, dependencies),
		);
